import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=08cf946c&scoped=true"
import script from "./CommentsModal.vue?vue&type=script&lang=js"
export * from "./CommentsModal.vue?vue&type=script&lang=js"
import style0 from "./CommentsModal.vue?vue&type=style&index=0&id=08cf946c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf946c",
  null
  
)

export default component.exports